/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { PhoneOff, Mic, MicOff } from "lucide-react";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app, db } from '../Admin/Config/Config';
import { doc, getDoc } from 'firebase/firestore';

export default function CallConnectedPage({ isConnected, onMute, channelName,isLoading, endCall }) {
  const [isMuted, setIsMuted] = useState(false);
  const [callDuration, setCallDuration] = useState(0);
// ======================== CALL TIMER ========================== //
  useEffect(() => {
    let interval;
    let customInterval;
    if (isConnected) {
      interval = setInterval(() => {
        setCallDuration((prev) => prev + 1);
      }, 1000);
      customInterval = setInterval(() => {
        timeReducingFunction();
      }, 10000);
    }
   
    return () => {
      clearInterval(interval);
      clearInterval(customInterval);}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConnected]);

  // ========================= TIME REDUCING FUNCTION ==================== //
  const timeReducingFunction = async() => {
    if(!channelName){
      return;
    }
    const functions = getFunctions(app, "asia-south1");
    const reduceTime = httpsCallable(functions, "timeReducingCall");
    try {
      await reduceTime({ channel_name: channelName, call_duration: callDuration });
    } catch (err) {
      console.error("Error calling function:", err.message);
    }
    
  }
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (seconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  };
  const [callData,setcallData] = useState({})
  const fetchDetails = async () => {
    if(channelName){
      const callDoc = await getDoc(
        doc(db, "bristu_talk_call_invites", channelName)
      );
      if (!callDoc.exists){
        return
      }
      setcallData(callDoc.data());
    }
  }
  useEffect(()=>{
    fetchDetails();
  },[])
  return (
    <div className='min-h-screen w-full bg-black px-4 sm:px-6 lg:px-8'>
      {isConnected && (
        <div className="min-h-screen w-full bg-black text-center space-y-4 sm:space-y-6 animate-fade-in py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row max-w-7xl bg-black items-center border p-4 sm:p-6 lg:p-8 rounded-lg justify-between w-full gap-4 sm:gap-6">
            <div className="flex flex-col items-center space-y-2">
              <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 bg-blue-600 rounded-full flex items-center justify-center text-lg sm:text-xl lg:text-2xl font-bold text-white shadow-lg ring-4 ring-blue-200/50">
                {callData?.caller_name &&
                  callData?.caller_name
                    .split(" ")
                    .map((word) => word.charAt(0).toUpperCase())
                    .join("")}
              </div>
              <p className="text-sm sm:text-base lg:text-lg font-medium text-gray-100 text-center">
                {callData?.caller_name ?? ""}
              </p>
            </div>

            <div className="flex items-center justify-center gap-1 h-12 sm:h-16 w-full sm:w-auto">
              {[...Array(26)].map((_, i) => (
                <div
                  key={i}
                  className="w-0.5 sm:w-1 bg-gradient-to-b from-blue-500 to-blue-700 rounded-full animate-pulse-wave"
                  style={{
                    height: `${Math.random() * 50 + 10}px`,
                    animationDelay: `${i * 0.15}s`,
                    animationDuration: "1.5s",
                  }}
                />
              ))}
            </div>

            <div className="flex flex-col items-center space-y-2">
              <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 bg-purple-600 rounded-full flex items-center justify-center text-lg sm:text-xl lg:text-2xl font-bold text-white shadow-lg ring-4 ring-purple-200/50">
                {callData?.receiver_name &&
                  callData?.receiver_name
                    .split(" ")
                    .map((word) => word.charAt(0).toUpperCase())
                    .join("")}
              </div>
              <p className="text-sm sm:text-base lg:text-lg font-medium text-gray-100 text-center">
                {callData?.receiver_name ?? ""}
              </p>
            </div>
          </div>
          <div className="flex items-center justify-center gap-4 mb-2">
            <h2 className="text-lg sm:text-xl lg:text-2xl font-base text-gray-100">
              Call Connected
            </h2>
          </div>

          <div className="space-y-4 pt-4 sm:pt-6">
            <div className="space-y-4 mb-8 sm:mb-12 text-center">
              <div className="text-3xl sm:text-4xl lg:text-[2.75rem] font-medium text-gray-200 tracking-tighter">
                {formatTime(callDuration)}
              </div>
              <div className="flex items-center justify-center gap-2 text-green-600">
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-xs sm:text-sm text-gray-100 font-medium">
                  Secure Connection
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full">
              <button
                onClick={() => {
                  setIsMuted(!isMuted);
                  onMute(!isMuted);
                }}
                className={`flex flex-col items-center group flex-1 py-3 sm:py-4 px-4 sm:px-6 rounded-xl transition-all ${
                  isMuted
                    ? "bg-red-50 text-red-600"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                <div className="relative">
                  {isMuted ? (
                    <MicOff className="w-6 h-6 sm:w-8 sm:h-8 mb-2" />
                  ) : (
                    <Mic className="w-6 h-6 sm:w-8 sm:h-8 mb-2" />
                  )}
                  <div
                    className={`absolute -inset-1 rounded-lg transition-opacity ${
                      isMuted ? "bg-red-100/10" : "bg-blue-100/10"
                    } opacity-0 group-hover:opacity-100`}
                  ></div>
                </div>
                <span className="text-xs sm:text-sm font-medium">
                  {isMuted ? "Unmute" : "Mute"}
                </span>
              </button>

              <button
                disabled={isLoading}
                onClick={() => {
                  endCall();
                }}
                className="flex flex-col items-center group flex-1 py-3 sm:py-4 px-4 sm:px-6 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-all"
              >
                <div className="relative">
                  <PhoneOff className="w-6 h-6 sm:w-8 sm:h-8 mb-2" />
                  <div className="absolute -inset-1 bg-red-100/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"></div>
                </div>
                <span className="text-xs sm:text-sm font-medium">End Call</span>
              </button>
            </div>

            <div className="mt-8 sm:mt-12 pt-4 sm:pt-6 border-t border-gray-300 w-full text-center">
              <p className="text-xs sm:text-sm text-gray-500">
                <span className="inline-block mr-2">🔒</span>
                Encrypted for your security
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
